export const PAGINATION_DEFAULTS = {
	current_page: 1,
	per_page: 10,
	last_page: 10
}
